var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHotelAlt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.845,
    height: 51.719,
    viewBox: "0 0 60.845 51.719",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hotel-alt-svgrepo-com",
    transform: "translate(-0.023 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3880",
    "data-name": "Path 3880",
    d: "M9.328,48.281v0A3.437,3.437,0,0,1,5.891,51.72H5.878a3.435,3.435,0,0,1-3.435-3.435V3.436A3.435,3.435,0,0,1,5.878,0h.013A3.437,3.437,0,0,1,9.328,3.438Z",
    transform: "translate(2.795 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3881",
    "data-name": "Path 3881",
    d: "M4.314,2.686h-2.4a1.945,1.945,0,0,0,0,3.888h2.4Z",
    transform: "translate(0 3.101)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3882",
    "data-name": "Path 3882",
    d: "M47.149,5.95H12.669A5.727,5.727,0,0,0,6.95,11.669V31.6a5.714,5.714,0,0,0,5.715,5.715H47.149a5.727,5.727,0,0,0,5.719-5.719V11.665A5.714,5.714,0,0,0,47.153,5.95h0Zm2.758,25.644a2.759,2.759,0,0,1-2.748,2.748H12.676A2.743,2.743,0,0,1,9.932,31.6V11.667A2.759,2.759,0,0,1,12.678,8.92H47.157A2.759,2.759,0,0,1,49.9,11.667Z",
    transform: "translate(8 6.871)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3883",
    "data-name": "Path 3883",
    d: "M13.175,9.765a2,2,0,0,0,2-2V3.694a2,2,0,1,0-4.008,0V7.763a2.006,2.006,0,0,0,2,2Z",
    transform: "translate(12.875 1.951)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3884",
    "data-name": "Path 3884",
    d: "M24.184,9.733a2,2,0,0,0,2-2V3.721a2,2,0,0,0-4.008,0V7.729A2,2,0,0,0,24.184,9.733Z",
    transform: "translate(25.59 1.982)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3885",
    "data-name": "Path 3885",
    d: "M13.487,2.686H31.233V6.574H13.487Z",
    transform: "translate(15.55 3.101)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3886",
    "data-name": "Path 3886",
    d: "M30.985,4.6a1.922,1.922,0,0,0-1.918-1.918H24.626V6.575h4.439a1.924,1.924,0,0,0,1.918-1.918Z",
    transform: "translate(28.415 3.102)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3887",
    "data-name": "Path 3887",
    d: "M14.384,16.048h-2.09V14.113H10.376V19.66h1.918V17.419h2.09V19.66H16.3V14.113H14.384Z",
    transform: "translate(11.957 16.299)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3888",
    "data-name": "Path 3888",
    d: "M19.192,14.808a4.1,4.1,0,0,0-4.747.026l.013-.009a2.656,2.656,0,0,0-.851,1.95c0,.056,0,.11,0,.166v-.006c0,.037,0,.08,0,.123a2.8,2.8,0,0,0,.442,1.513l-.006-.011a2.562,2.562,0,0,0,1.088.944l.015.006a4.137,4.137,0,0,0,1.552.3c.06,0,.121,0,.181,0h-.009l.11,0a3.938,3.938,0,0,0,1.64-.356l-.024.011a2.417,2.417,0,0,0,1.049-.957l.006-.011a3.124,3.124,0,0,0,.364-1.47c0-.041,0-.084,0-.125v.006c0-.047,0-.1,0-.159a2.657,2.657,0,0,0-.825-1.929Zm-1.416,3.353a1.228,1.228,0,0,1-.873.364c-.028,0-.056,0-.082,0h0l-.058,0a1.268,1.268,0,0,1-.892-.364,2.287,2.287,0,0,1,0-2.422l-.006.009a1.4,1.4,0,0,1,1.883,0h0a1.541,1.541,0,0,1,.353.985,1.367,1.367,0,0,1-.009.164v-.006a1.95,1.95,0,0,1,.011.2,1.878,1.878,0,0,1-.34,1.077l0-.006Z",
    transform: "translate(15.688 16.243)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3889",
    "data-name": "Path 3889",
    d: "M16.751,15.478H18.7v4.183h1.918V15.478h1.952V14.112H16.751Z",
    transform: "translate(19.32 16.298)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3890",
    "data-name": "Path 3890",
    d: "M21.773,17.312h2.974V16.17H21.773v-.881h3.2V14.112H19.855v5.547h5.219V18.4h-3.3Z",
    transform: "translate(22.905 16.298)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3891",
    "data-name": "Path 3891",
    d: "M24.667,14.113H22.749V19.66h4.909V18.294H24.669Z",
    transform: "translate(26.248 16.299)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3892",
    "data-name": "Path 3892",
    d: "M11.2,15l1.8-.952L14.812,15l-.345-2,1.452-1.418-2-.293L13,9.454l-.9,1.832-2,.293L11.549,13Z",
    transform: "translate(11.635 10.918)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3893",
    "data-name": "Path 3893",
    d: "M14.3,15l1.8-.952,1.8.952-.345-2L19,11.579l-2-.293-.9-1.832-.9,1.832-2.021.293L14.627,13Z",
    transform: "translate(15.19 10.918)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3894",
    "data-name": "Path 3894",
    d: "M17.376,15l1.8-.952,1.8.952-.345-2,1.452-1.418-2-.293-.9-1.832-.9,1.832-2.021.293L17.725,13Z",
    transform: "translate(18.747 10.918)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3895",
    "data-name": "Path 3895",
    d: "M20.455,15l1.8-.952,1.8.952L23.7,13l1.452-1.418-2-.293-.9-1.832-.9,1.832-2.021.293L20.8,13Z",
    transform: "translate(22.303 10.918)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3896",
    "data-name": "Path 3896",
    d: "M25.322,9.454l-.9,1.832-2,.293L23.869,13l-.345,2,1.8-.952,1.8.952-.345-2,1.47-1.418-2.021-.293Z",
    transform: "translate(25.866 10.918)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3897",
    "data-name": "Path 3897",
    d: "M6.142,2.686h9.59V6.574H6.142Z",
    transform: "translate(7.067 3.101)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotelAlt);
export default __webpack_public_path__ + "static/media/hotel-alt.89cf81f992e9b714455aa7b96a78f1d4.svg";
export { ForwardRef as ReactComponent };